import { PureComponent, ReactNode } from "react";
import { Form, Modal } from "react-bootstrap";
import SelectInput from "../../shared/select/SelectInput";
import EducationalBookletFilterModalStates, { EducationalBookletFilterModalProps } from "./EducationalBookletFilterModal.models";

export default class EducationalBookletFilterModal extends PureComponent<EducationalBookletFilterModalProps, EducationalBookletFilterModalStates>{

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    setFileType = (fileType?: any) => {
        this.setState({ fileType: fileType });
    }

    handleRequest = () => {
        this.props.handleSearch(this.state.name, this.state.fileType);
        this.setState({ fileType: undefined, name: undefined });
    }

    render(): ReactNode {
        let { showModal, closeModal, handleBookMark, showBookMarks } = this.props;
        let { name, fileType } = this.state;
        return <>
            <Modal show={showModal} onHide={closeModal} animation={true}>

                <Modal.Body >
                    <Form dir="rtl">
                        <Form.Group>
                            <Form.Label>
                                نام نویسنده
                            </Form.Label>
                            <Form.Control type="text" value={name} onChange={(v) => this.setState({ name: v.target.value })}>
                            </Form.Control>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>
                                نوع فایل
                            </Form.Label>
                            <SelectInput inputvalue={fileType} isNullAble={true} datas={[{ title: "متنی", value: 0 },
                             { title: "ویدئو", value: 1 },
                             { title: "صوت", value: 2 },
                             { title: "عکس", value: 3 },
                             { title: "فایل پی دی اف", value: 4 }
                             ]} name={"fileTypes"} value={this.setFileType} />
                        </Form.Group>
                    </Form>
                    <br />
                    {
                        showBookMarks ?
                            <button className="btn btn-outline-warning" onClick={handleBookMark}>نمایش تمام جزوات</button>
                            :
                            <button className="btn btn-outline-success" onClick={handleBookMark}>نمایش جزوات نشان شده</button>
                    }
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-success tk-float-right" onClick={this.handleRequest}>اعمال فیلتر</button>
                    <button className="btn btn btn-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>
    }
}